
import React from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { EpisodeData, SeriesData } from '../context/FileLibraryContext';
import { FormControl, Grid2, MenuItem, Paper, Select } from '@mui/material';
import { IoMdDownload } from 'react-icons/io';
import Preloader from './Preloader';

export interface AudioPlayerProps {
    series: SeriesData;
    episode: EpisodeData;
}

const AudioPlayerComponent: React.FC<AudioPlayerProps> = (props: AudioPlayerProps) => {

    return (
        <AudioPlayer
            src={props.episode.streamLinks[0].url}
            onPlay={e => console.log("onPlay. streamLink: ", props.episode.streamLink)}
        />
    )
}

export default AudioPlayerComponent;